import { carleadCreationGetInitialProps } from '@wkda/carlead-creation-components';
import {
  BaseConversationalLeadPage,
  CarleadHIWWhyChooseWkdaFaq,
  CarleadStepCompoundBoughtOrOrderedCarConsent,
  createBoughtOrOrderedCarChatFlow,
  MatomoHelmet,
} from '@wkda/marketing-components';

function CarleadCreation() {
  return (
    <>
      <MatomoHelmet />
      <BaseConversationalLeadPage
        content={CarleadHIWWhyChooseWkdaFaq}
        customFlow={createBoughtOrOrderedCarChatFlow}
        manualForm={<CarleadStepCompoundBoughtOrOrderedCarConsent />}
        showTrustPilot={true}
        howItWorksShowCta={true}
      />
    </>
  );
}

CarleadCreation.getInitialProps = carleadCreationGetInitialProps;

export default CarleadCreation;
